import { useTranslation } from 'react-i18next';

interface ProductHeaderProps {
  name: string;
  seller: string;
  code: string;
}

export function ProductHeader({ name, seller, code }: ProductHeaderProps) {
  const { t } = useTranslation('product');
  return (
    <div>
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1">
          <h1
            data-testid="product-detail-name"
            className="text-2xl text-neutral-900 font-semibold mb-2"
          >
            {name}
          </h1>
          <button className="text-sm text-neutral-600 hover:text-primary-500 font-normal mb-3">
            {t('product.by')} {seller} →
          </button>
        </div>
      </div>
      <p className="text-neutral-600 font-normal leading-relaxed">
        {t('product.product_code')}: {code}
      </p>
    </div>
  );
}
